import state from "./moduleMailRuleState";
import mutations from "./moduleMailRuleMutations";
import actions from "./moduleMailRuleActions";
import getters from "./moduleMailRuleGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}